import "./src/styles/global.scss"

const addScript = url => {
    const script = document.createElement("script")
    script.src = url
    script.async = true
    document.body.appendChild(script)
}
export const onClientEntry = () => {
    window.onload = () => {
        // <script async src="//static.getclicky.com/101343449.js"></script>
        addScript("//static.getclicky.com/101343449.js")
    }
}